var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconAnswer({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.117 14.5518C12.117 13.2829 12.477 12.6657 13.763 11.7568C14.7575 11.071 15.0833 10.5566 15.0833 9.71645C15.0833 8.65331 14.2946 7.93313 13.1114 7.93313C11.8082 7.93313 11.0196 8.61906 10.7624 10.0079L9.44206 9.83644C9.61347 8.82479 9.90502 8.22468 10.5395 7.65882C11.2081 7.05864 12.117 6.75 13.1629 6.75C15.1862 6.75 16.5579 7.93313 16.5579 9.68212C16.5579 10.488 16.3007 11.1567 15.8034 11.7054C15.4948 12.0312 15.2548 12.2199 14.4831 12.7342C13.5744 13.3343 13.3687 13.7116 13.3687 14.7404V15.4777H12.117V14.5518ZM13.8145 18.1526C13.8145 18.7527 13.3172 19.25 12.7171 19.25C12.0998 19.25 11.6197 18.7699 11.6197 18.1526C11.6197 17.5353 12.0998 17.0552 12.7171 17.0552C13.3172 17.0552 13.8145 17.5525 13.8145 18.1526ZM13 25.5C6.10745 25.5 0.5 19.8925 0.5 13C0.5 6.10745 6.10745 0.5 13 0.5C19.8925 0.5 25.5 6.10745 25.5 13C25.5 19.8925 19.8925 25.5 13 25.5ZM13 1.75C6.79669 1.75 1.75 6.79669 1.75 13C1.75 19.2033 6.79669 24.25 13 24.25C19.2033 24.25 24.25 19.2033 24.25 13C24.25 6.79669 19.2033 1.75 13 1.75Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAnswer);
export default __webpack_public_path__ + "static/media/iconAnswer.e49815f99218867113398ab209070b1e.svg";
export { ForwardRef as ReactComponent };